'use client';

import { Spacing } from '@lichtblick/theme';
import styled from 'styled-components';

export const StyledMList = styled.ul`
  width: 100%;
  & > :not(:last-of-type) {
    margin-bottom: ${Spacing.Xs};
  }
`;
